var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_1057)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 34H30.6V26.3011C30.6 24.1891 29.6683 23.0107 27.9974 23.0107C26.1791 23.0107 25.1 24.2386 25.1 26.3011V34H20.7V19.7H25.1V21.3081C25.1 21.3081 26.4805 18.8857 29.5913 18.8857C32.7032 18.8857 35 20.7847 35 24.7139V34ZM15.6862 17.413C14.2023 17.413 13 16.2009 13 14.706C13 13.2122 14.2023 12 15.6862 12C17.169 12 18.3713 13.2122 18.3713 14.706C18.3724 16.2009 17.169 17.413 15.6862 17.413ZM13 34H18.5V19.7H13V34Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_1057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.ef96bb4e978507817922abba9a6091ac.svg";
export { ForwardRef as ReactComponent };